import type { SVGProps } from 'react';

export const OvercastLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <title>Overcast</title>
    <defs>
      <linearGradient id="overcast-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#f9b030" />
        <stop offset="1" stopColor="#d96400" />
      </linearGradient>
    </defs>
    <rect width="512" height="512" fill="url(#overcast-bg)" />
    <circle cx="255" cy="255" r="175" fill="white" stroke="#3b4555" strokeWidth="23" />
    <path
      d="M160,181.1s-24.2,27.3-24.2,75,24.2,73.9,24.2,73.9"
      fill="none"
      stroke="#fc7e0f"
      strokeWidth="23"
      strokeLinecap="round"
    />
    <path
      d="M352.8,181.1s24.2,27.3,24.2,75-24.2,73.9-24.2,73.9"
      fill="none"
      stroke="#fc7e0f"
      strokeWidth="23"
      strokeLinecap="round"
    />
    <path
      d="M314.2,213s16.3,20.3,15.9,43c-.5,27.3-15.7,42.3-15.7,42.3"
      fill="none"
      stroke="#fc7e0f"
      strokeWidth="23"
      strokeLinecap="round"
    />
    <path
      d="M197.8,213s-16.3,20.3-15.9,43c.5,27.3,15.7,42.3,15.7,42.3"
      fill="none"
      stroke="#fc7e0f"
      strokeWidth="23"
      strokeLinecap="round"
    />
    <circle cx="255" cy="255" r="32" fill="#3b4555" />
    <path fill="#3b4555" d="M260.4,284.9l-22.7-6.1-37.8,141.2,22.7,6.1,37.8-141.2Z" />
    <path fill="#3b4555" d="M251.6,284.7l22.6-6,37.6,141.3-22.6,6-37.6-141.3Z" />
    <path fill="#3b4555" d="M230.6,360.9l8.4-8.6,58.2,56.7-8.4,8.6-58.2-56.7Z" />
    <path fill="#3b4555" d="M279.9,361.2l-7.6-7.7-57.7,57.3,7.6,7.7,57.7-57.3Z" />
  </svg>
);
